/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class DegreeOfConsiderationEnum.
* @enum {}
* @readonly
*/
export default class DegreeOfConsiderationEnum {
    
        /**
         * value: "Considering"
         * @const
         */
        "Considering" = "Considering";

    
        /**
         * value: "NotConsidered"
         * @const
         */
        "NotConsidered" = "NotConsidered";

    

    /**
    * Returns a <code>DegreeOfConsiderationEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/DegreeOfConsiderationEnum} The enum <code>DegreeOfConsiderationEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

